import AbstractListStrategy from "./AbstractListStrategy.js";

/**
 * Strategy to decorate an {@link AbstractListStrategy} within a
 * {@link ListSourceWidget}.
 *
 * @abstract
 * @param {AbstractListStrategy} strategy - Strategy to decorate
 */
export default class AbstractDecorator extends AbstractListStrategy {
	constructor({ strategy }) {
		super(...arguments);

		this._strategy = strategy;
	}

	cssClass() {
		return [...this._strategy.cssClass(), this._cssClass];
	}

	setListSourceWidget(listSourceWidget) {
		this._strategy.setListSourceWidget(listSourceWidget);
	}

	makeItemsRenderable(...rest) {
		return this._strategy.makeItemsRenderable(...rest);
	}

	baseCss() {
		return this._strategy.baseCss();
	}

	renderEmptyOn(html) {
		this._strategy.renderEmptyOn(html);
	}

	renderLoadingOn(html) {
		this._strategy.renderLoadingOn(html);
	}

	itemsRenderer(...rest) {
		return this._strategy.itemsRenderer(...rest);
	}

	makeItemRenderable(...rest) {
		return this._strategy.makeItemRenderable(...rest);
	}
}
